import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { FiBarChart2 } from 'react-icons/fi';
import NodeWrapper from './NodeWrapper';
import { VISUAL_NODE_HEIGHT_CLASS } from '../layoutConfig';
import { getNodeAccent } from '../config/nodeVisualConfig';

const CandleNode = memo(({ data, selected }) => {
  const accent = getNodeAccent('candle_node', data);
  return (
    <NodeWrapper
        selected={selected}
        title="Candlestick Node"
        type="VISUALIZATION"
        accent={accent}
        icon={FiBarChart2}
        className={`${VISUAL_NODE_HEIGHT_CLASS} flex flex-col`}
        isHighlighted={data.isHighlighted}
    >
        {/* Input: Data Source */}
        <Handle
            type="target"
            id="input_0"
            position={Position.Left}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />

        <div className="space-y-3">
            {/* BULL/BEAR swatches use the user-configurable chart colours — kept as-is */}
            <div className="flex items-center justify-between gap-4 bg-bg-3 p-3 rounded-lg border border-[var(--divider)]">
                 <div className="flex flex-col items-center gap-1.5">
                     <div className="w-8 h-10 rounded-sm border border-transparent shadow-sm relative" style={{ backgroundColor: data.upColor || '#00C292', borderColor: data.wickUpColor || data.upColor || '#00C292' }}>
                        <div className="absolute top-0 bottom-0 left-1/2 w-0.5 -ml-px" style={{ backgroundColor: data.wickUpColor || data.upColor || '#00C292' }}></div>
                     </div>
                     <span className="text-[9px] text-fg-3 font-bold uppercase tracking-wider">Bull</span>
                 </div>
                 <div className="flex flex-col items-center gap-1.5">
                     <div className="w-8 h-10 rounded-sm border border-transparent shadow-sm relative" style={{ backgroundColor: data.downColor || '#E46A76', borderColor: data.wickDownColor || data.downColor || '#E46A76' }}>
                        <div className="absolute top-0 bottom-0 left-1/2 w-0.5 -ml-px" style={{ backgroundColor: data.wickDownColor || data.downColor || '#E46A76' }}></div>
                     </div>
                     <span className="text-[9px] text-fg-3 font-bold uppercase tracking-wider">Bear</span>
                 </div>
            </div>
        </div>

        {/* Output: Configuration Data — handle tinted to the node accent */}
        <Handle
            type="source"
            position={Position.Right}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />
    </NodeWrapper>
  );
});

export default CandleNode;
